import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { PageHeader } from '../components/Layout';
import { Badge, QueryBoundary, Table, Td, Th } from '../components/ui';
import { dateOnly, num } from '../lib/format';

export default function Datasets() {
  const q = useQuery({ queryKey: ['datasets'], queryFn: () => api.datasets() });

  return (
    <>
      <PageHeader
        title="Datasets"
        description="Built training datasets (scripts.build_dataset). Each is the input to a training run; models point back to one by hash."
      />
      <QueryBoundary q={q} isEmpty={q.data?.items.length === 0}>
        {q.data && (
          <Table>
            <thead>
              <tr>
                <Th>Hash</Th>
                <Th>Strategy</Th>
                <Th>Symbols / TF</Th>
                <Th>Range</Th>
                <Th className="text-right">Rows</Th>
                <Th className="text-right">Positive</Th>
                <Th className="text-right">Ambiguous</Th>
                <Th>Built</Th>
              </tr>
            </thead>
            <tbody>
              {q.data.items.map((d) => (
                <tr key={d.dataset_hash} className="hover:bg-slate-800/30">
                  <Td>
                    <Link className="text-sky-400 hover:underline" to={`/datasets/${d.dataset_hash}`}>
                      {d.dataset_hash}
                    </Link>
                  </Td>
                  <Td>{d.strategy_id}</Td>
                  <Td className="text-xs">
                    {d.symbols.join(', ')} · {d.timeframe}
                  </Td>
                  <Td className="whitespace-nowrap text-xs text-slate-400">
                    {dateOnly(d.from_utc)} → {dateOnly(d.to_utc)}
                  </Td>
                  <Td className="text-right tabular-nums">{num(d.row_count, 0)}</Td>
                  <Td className="text-right tabular-nums">
                    {d.row_count > 0 ? `${Math.round((d.positive_count / d.row_count) * 100)}%` : '—'}
                  </Td>
                  <Td className="text-right tabular-nums">
                    {d.ambiguous_count > 0 ? <Badge tone="warn">{d.ambiguous_count}</Badge> : d.ambiguous_count}
                  </Td>
                  <Td className="text-xs text-slate-500">{dateOnly(d.built_at_utc)}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </QueryBoundary>
    </>
  );
}
